var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-nowrap place-items-start"},[_c('div',{staticClass:"w-full"},[_c('nav',[_c('div',{staticClass:"flex flex-row gap-4 items-center"},_vm._l((_vm.$page.props.groups),function(group,index){return _c('div',{key:'ad_' + index,staticClass:"menu",class:{
              active: decodeURI(_vm.$page.url).includes('group=' + group),
            }},[_c('Link',{attrs:{"href":_vm.route('admin.ad') + '?group=' + group}},[_vm._v(_vm._s(group))])],1)}),0)]),_vm._v(" "),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }